import { Outlet } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import { Grid, Container } from '@mui/material';

const RootStyle = styled('div')(({ theme }) => ({
	height: '100%',
	padding: '50px 0px 50px 0px'
}));

export default function TokenLayout() {
	return <RootStyle>
		<Grid container justifyContent='center'>
			<Grid item xs={12} md={4}>
				<Container sx={{ textAlign: 'center' }}>
					<Outlet />
				</Container>
			</Grid>
		</Grid>
	</RootStyle>
}